export function absurd(_: never): Error {
  return new Error('absurd');
}
